module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var fontService = require('FontService').default;

var size = fontService.getFontSizes();
var fonts = fontService.getFonts();

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Header</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6\">\r\n        <select name=\"headerFontFamily\" class=\"style-font\" style=\"width: 108px;\" id=\"headerFontFamily\">\r\n            \r\n        </select>\r\n    </div>\r\n    <div class=\"col-md-4\" style=\"text-align: right;\">\r\n        <select name=\"headerFontSize\" id=\"headerFontSize\" class=\"style-font\" style=\"width: 45px;\">\r\n            ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">\r\n                    ")
    ; __append(escapeFn(size[i]))
    ; __append("\r\n                </option>\r\n            ")
    ;  }; 
    ; __append("\r\n            <option></option>\r\n        </select>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 subsection nopadding-r\">\r\n        <div>\r\n            <div id=\"main_text_font_family_custom\">\r\n                <input id=\"customFontFamily\" style=\"margin-bottom:2px;\" name=\"customFontFamily\" type=\"text\" value=\"")
    ; __append(escapeFn( customFontFamily ))
    ; __append("\" ")
    ; __append(escapeFn( customFontFamilyDisabled ))
    ; __append("/>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"row\"> \r\n    <div class=\"col-md-6\">\r\n        <input id=\"headerTextColorPicker\" name=\"headerTextColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( headerTextColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 20px;\" />\r\n        <input id=\"headerTextColor\" name=\"headerTextColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( headerTextColor ))
    ; __append("\" />\r\n    </div>\r\n    <div class=\"col-md-4\" style=\"text-align: right;\">\r\n        <img id=\"headerBoldText\" name=\"textWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\" style=\"width: 20px; height: 20px; background-color: ")
    ; __append(escapeFn( headerBoldSelection ))
    ; __append("\" />\r\n        <img id=\"headerItalicText\" name=\"textStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\"  style=\"width: 20px; height: 20px; background-color: ")
    ; __append(escapeFn( headerItalicSelection ))
    ; __append("\" />\r\n    </div>\r\n</div>")
  }
  return __output;

}